import { render, staticRenderFns } from "./ContactUsEn.vue?vue&type=template&id=2a8d8345&"
import script from "./ContactUsEn.vue?vue&type=script&lang=js&"
export * from "./ContactUsEn.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsEn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports